module.exports = __webpack_public_path__ + "img/account.0c72dac3.svg";